import React from "react";
import { render } from "react-dom";
import "./index.scss";
import { unregister } from "./serviceWorker";
import Router from "./routes";

render(<Router />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
unregister();
